
export const LIMIT_ITEMS = 5;

export const evaluateItemClass = ({i, overOnCard, playlist, itemClass}) => {
    let classGroup = overOnCard !== false  ? overOnCard !== i && ' Alpha ' : ' ';
   // classGroup = classGroup + (i === 0) ? ' FirstItem ' : (i === playlist.length - 1) && " LastItem ";
    classGroup = classGroup + ' PlaylistItemContainer ';
    return classGroup;
}